import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import moment from 'moment'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import { useMemo } from 'modules/core/hooks/useMemo'
import { dateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type { Automation } from 'modules/automations/store/models/Automation'

export interface Props {
  automation: Automation
  setDay: (day: number) => void
  selectedMonthday?: string
  setSelectedMonthday: (day: string) => void
}

export default function Monthly({
  automation,
  setSelectedMonthday,
  selectedMonthday,
  setDay,
}: Props) {
  const form = useMemo(
    () =>
      new Form(
        {
          repeat_data: dateToString(
            moment().set('date', Number(automation.attributes.repeat_data)),
            'ui'
          ),
        },
        {
          repeat_data: 'string',
        }
      ),
    [automation.attributes.repeat_data]
  )

  const pickedDayTranslation = useMemo(() => {
    return i18n.t('automations.new.subtitle_monthly_trigger', { day: selectedMonthday })
  }, [selectedMonthday])

  return (
    <>
      <DayPicker
        label={i18n.t('automations.actions.time.monthly_label')}
        field={form.get('repeat_data')}
        onChange={(field) => {
          setSelectedMonthday(String(stringToDate(field.value, 'ui').date()))
          setDay(stringToDate(field.value, 'ui').date())
        }}
      />

      <Box paddingTop="s16">{pickedDayTranslation}</Box>
    </>
  )
}
